import(/* webpackMode: "eager", webpackExports: ["SetTranslationData"] */ "/home/liamto-d-mo-officielle/www/apps/front/src/i18n/SetTranslationData.tsx");
